<template>
    <div>
        <template v-if="list.length > 0">
            <div class="list-group" :class="listClass">
                <template v-for="item in list">
                    <div class="list-group-item">
                        <div class="row">
                            <div class="col align-self-center">
                                <slot :item="item" :hasCurrentHash="hasCurrentHash" />
                            </div>
                            <template v-if="!readOnly">
                                <div class="col-auto">
                                    <template v-if="editUrl">
                                        <a :href="itemEditUrl(item)" class="btn btn-sm btn-outline-primary">Éditer</a>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="handleEditButtonClicked(item)">Éditer</button>
                                    </template>
                                    <button type="button" class="btn btn-sm btn-outline-danger" @click="handleDeleteButtonClicked(item)">Supprimer</button>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </template>

        <template v-if="!readOnly">
            <slot name="button" :on="{ click:handleAddButtonClicked }">
                <button type="button" class="btn btn-outline-primary btn-block mt-2" @click="handleAddButtonClicked">
                    {{ addLabel }}
                </button>
            </slot>

            <b-modal
                data-legacy
                v-model="modalVisible"
                ok-title="Ok"
                :ok-disabled="loading || hasLoadingFields"
                cancel-title="Annuler"
                no-close-on-backdrop
                @ok="handleModalOkClicked"
                @hidden="handleModalHidden"
                ref="modal"
            >
                <template v-slot:modal-title>
                    <template v-if="isCreation">{{ addLabel }}</template>
                    <template v-else>Édition - {{ label }}</template>
                </template>
                <template v-if="currentItem">
                    <aca-form
                        :action="formEndpoint"
                        :no-alert="noAlert"
                        @submit="handleFormSubmitted"
                        @success="handleFormSuccess"
                        @error="handleFormError"
                        ref="form"
                    >
                        <slot name="modal"
                            :item="currentItem"
                            :update="updateCurrentItem"
                            :handleLoadingChanged="handleLoadingChanged"
                        />
                    </aca-form>
                    <template v-if="hasLoadingFields">
                        <div class="alert alert-warning mb-0">
                            Attendez la fin du téléchargement avant de pouvoir envoyer le formulaire...
                        </div>
                    </template>
                </template>
                <template v-slot:modal-ok>
                    <span class="d-inline-block" style="min-width: 2em">
                        <template v-if="loading">
                            <span class="spinner-border spinner-border-sm"></span>
                        </template>
                        <template v-else>
                            Ok
                        </template>
                    </span>
                </template>
            </b-modal>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import AcaForm from './Form.vue';
    import { BModal, ModalPlugin } from 'bootstrap-vue';
    import axios from 'axios';

    Vue.use(ModalPlugin);

    function resolveRoute(endpoint, id) {
        return endpoint.replace(':id', id);
    }

    export default {
        components: {
            BModal,
            AcaForm,
        },
        props: {
            items: Array,
            createEndpoint: String,
            updateEndpoint: String,
            deleteEndpoint: String,
            editUrl: String,
            label: String,
            addLabel: {
                type: String,
                default: 'Ajouter'
            },
            noAlert: Boolean,
            readOnly: Boolean,
            listClass: String,
        },
        data() {
            return {
                list: this.items ? [...this.items] : [],
                currentItem: null,
                modalVisible: false,
                isCreation: false,
                loading: false,
                loadingFields: null,
            }
        },
        computed: {
            formEndpoint() {
                const id = this.currentItem ? this.currentItem.id : null;
                return this.isCreation
                    ? this.createEndpoint
                    : resolveRoute(this.updateEndpoint, id);
            },
            deleteConfirmMessage() {
                return `Êtes-vous sûr de vouloir supprimer cet élément (${this.label}) ?`;
            },
            hasLoadingFields() {
                return Object.values(this.loadingFields || {}).some(loading => !!loading);
            },
        },
        methods: {
            itemEditUrl(item) {
                return resolveRoute(this.editUrl, item.id);
            },
            updateCurrentItem(props) {
                this.currentItem = {
                    ...this.currentItem,
                    ...props,
                }
            },
            async handleDeleteButtonClicked(item) {
                if(! window.confirm(this.deleteConfirmMessage)) {
                    return;
                }
                axios.delete(resolveRoute(this.deleteEndpoint, item.id)).then(() => {
                    this.list = this.list.filter(i => i.id !== item.id);
                });
            },
            handleAddButtonClicked() {
                this.modalVisible = true;
                this.currentItem = {};
                this.isCreation = true;
            },
            handleEditButtonClicked(item) {
                this.modalVisible = true;
                this.currentItem = { ...item };
                this.isCreation = false;
            },
            handleModalHidden() {
                this.currentItem = null;
            },
            handleFormSubmitted(e) {
                this.loading = true;
            },
            handleFormSuccess(response) {
                const newItem = response.data.data;
                if(this.isCreation) {
                    if(this.editUrl) {
                        location.href = this.itemEditUrl(newItem);
                        return;
                    }
                    this.list = [...this.list, newItem];
                } else {
                    this.list = this.list.map(item => item.id === newItem.id ? newItem : item);
                }
                this.modalVisible = false;
                this.loading = false;
            },
            handleFormError() {
                this.loading = false;
            },
            handleModalOkClicked(e) {
                e.preventDefault();
                this.$refs.form.submit();
            },
            handleLoadingChanged(field, loading) {
                this.loadingFields = {
                    ...this.loadingFields,
                    [field]: !!loading,
                }
            },

            // item utils
            hasCurrentHash(hash) {
                return location.hash === hash;
            },
        },
    }
</script>
